/**
 * Depth-limit UI, currently dormant.
 *
 * History stopped being a paid differentiator on 2026-08-25: weekly surveys
 * meant a capped window was four data points, which broke the charts that
 * sell the product rather than protecting anything worth protecting.
 *
 * Both pieces below are therefore pass-throughs today. They are kept because
 * depth is expected to return as RECENCY once uploads are weekly, and the
 * call sites that wrap range controls are the exact places that will need it
 * again. When it returns, this is the only file that changes, and the lock
 * shows a popover in place rather than navigating: a click that yanks
 * someone off the page they are reading is a poor way to sell to them.
 */

export function RangeLockWrap({ children }) {
  return children;
}

export function DepthNotice() {
  return null;
}

export default RangeLockWrap;
